import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { SalienteLibrarySharedModule } from '@saliente/library';

import { MasterviewComponent } from './masterview.component';
import { ClientHeaderComponent } from './headers/notUsed/client.header.component';
import { DefaultHeaderComponent } from './headers/notUsed/default.header.component';
import { ExpertHeaderComponent } from './headers/notUsed/expert.header.component';
import { HrExpertHeaderComponent } from './headers/notUsed/hrexpert.header.component';
import { SubcontractorHeaderComponent } from './headers/notUsed/subcontractor.header.component';
import { MasterviewHeaderComponent } from './headers/masterview.header.component';
import { HeaderHelpComponent } from './headers/header-help.component';
import { HeaderProfileComponent } from './headers/header-profile.component';
import { HeaderRolesComponent } from './headers/header-roles.component';
import { HeaderCompanyListComponent } from './headers/header-company-list.component';
import { HeaderHelpMenuEditorComponent } from './headers/header-help-menu-editor.component';
import { HeaderHelpVideoEditorComponent } from './headers/header-help-video-editor.component';

const COMPONENTS = [MasterviewComponent, MasterviewHeaderComponent, ClientHeaderComponent, DefaultHeaderComponent, ExpertHeaderComponent, HrExpertHeaderComponent, SubcontractorHeaderComponent, HeaderHelpComponent, HeaderProfileComponent, HeaderRolesComponent, HeaderCompanyListComponent, HeaderHelpMenuEditorComponent, HeaderHelpVideoEditorComponent];

@NgModule({
	imports: [
		CommonModule, FormsModule, RouterModule, SalienteLibrarySharedModule, DragDropModule
	],
	declarations: [
		...COMPONENTS
	],
	exports: [
		...COMPONENTS
	],
	providers: []
})
export class MasterViewModule {
	constructor() {

	}
}
